export default __webpack_public_path__ + "static/media/st1.98c1132a.jpeg";